import apiService from "./apiService";

const requestPaymentSearch = (query) => {
  const {mobileNumber, payFor} = query
  return apiService.get(URIS_D("paymentSearch", mobileNumber, payFor))
}

const requestPaymentVerification = (verificationPayload) => {
  return apiService.post(URIS.paymentVerification, verificationPayload)
}

export {requestPaymentSearch, requestPaymentVerification}

const URIS_D = (url, param1, param2) => {
  return {
    paymentSearch: `/v1/admin/payment-search?user=${param1}&status=INITIATED&type=ESEWA&pay_for=${param2}`,
  }[url]
}

const URIS = {
  paymentVerification: '/v1/payments/verifications',
}


